import { useEffect, useState } from "react";

const CONSENT_STORAGE_KEY = "sale-ford-cookie-consent";

function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const savedConsent = localStorage.getItem(CONSENT_STORAGE_KEY);

    if (!savedConsent) {
      setIsVisible(true);
      return;
    }

    if (savedConsent === "accepted" && window.gtag) {
      window.gtag("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
      });
    }

    if (savedConsent === "declined" && window.gtag) {
      window.gtag("consent", "update", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
      });
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem(CONSENT_STORAGE_KEY, "accepted");

    if (window.gtag) {
      window.gtag("consent", "update", {
        ad_storage: "granted",
        ad_user_data: "granted",
        ad_personalization: "granted",
        analytics_storage: "granted",
      });
    }

    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem(CONSENT_STORAGE_KEY, "declined");

    if (window.gtag) {
      window.gtag("consent", "update", {
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
        analytics_storage: "denied",
      });
    }

    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 z-[9999] mx-auto w-auto max-w-4xl rounded-2xl border border-gray-200 bg-white p-5 shadow-2xl">
      <div className="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
        <div className="lg:pr-6">
          <h2 className="text-lg font-semibold text-fordBlue">
            Този уебсайт използва бисквитки
          </h2>
          <p className="mt-2 text-sm leading-6 text-gray-600">
            Бисквитките ни позволяват да подобрим функционалността на сайта, да
            разберем как взаимодействате с него и да ви предоставяме
            персонализирани оферти и съдържание. Можете да приемете всички
            бисквитки или да управлявате вашите предпочитания.
          </p>
        </div>
        <div className="flex flex-col gap-3 sm:flex-row lg:flex-shrink-0">
          <button
            type="button"
            onClick={handleDecline}
            className="px-6 py-2 text-sm font-medium transition border rounded-full border-fordBlue text-fordBlue hover:bg-gray-100"
          >
            Откажи
          </button>

          <button
            type="button"
            onClick={handleAccept}
            className="px-6 py-2 text-sm font-medium text-white transition rounded-full bg-fordBlue hover:opacity-90"
          >
            Приеми
          </button>
        </div>
      </div>
    </div>
  );
}

export default CookieBanner;
